import { Events } from './Events';

/**
 * singleton helper methods related to DOM
 * @class
 */

interface Styles {
  [index:string]: string
}

class DOM {

  constructor() {
  }

  /**
   * wait for class name to be applied
   * @param {string}      className [description]
   * @param {HTMLElement} element   [description]
   * @return {Promise}
   */
  public waitForClass(className:string, element:HTMLElement) {
    return new Promise(function (resolve, reject) {
      var operationTimeout: number = 200,
          keepSearching: boolean = true,
          step: () => void;


      step = function() {
        if (element.classList.contains(className)) {

          // just to make sure styles of class have been applied
          setTimeout(function() {
            resolve();
          }, 20);
        } else if(!keepSearching) {
          reject();
        } else {
          window.requestAnimationFrame(step);
        }
      }

      window.requestAnimationFrame(step);

      setTimeout(function() {
        keepSearching = false;
      }, operationTimeout);
    });
  }

  /**
   * wait for styles to be applied to element
   * @param {HTMLElement} element [description]
   * @param {Styles}      styles  [description]
   * @return {Promise}
   */
  public waitForStyles(element:HTMLElement, styles:Styles) {

    return new Promise(function(resolve, reject) {
      var key: string,
          keepSearching: boolean = true,
          operationTimeout: number = 200,
          allStylesFound: boolean = false,
          step: () => void;

      step = function() {

        allStylesFound = true;

        // check for styles
        for (key in styles) {
          if (styles.hasOwnProperty(key)) {

            if(!keepSearching) {
              reject();
            }

            if(element.style[key] !== styles[key]) {
              //console.log('not set: ' + element.style[key] + ' vs ' + styles[key]);
            }
          }
        }

        if(allStylesFound) {
          resolve();
        }
      }

      window.requestAnimationFrame(step);

      setTimeout(function() {
        keepSearching = false;
      }, operationTimeout);
    });
  }

  /**
   * Wait for when element is visible on the screen
   * @param {HTMLElement} element
   */
  public waitForVisibility(element: HTMLElement) {
    var self = this;

    return new Promise(function(resolve, reject) {

      function searching() {
        var rect = element.getBoundingClientRect();

        if (!rect) {
          reject();
        }

        // if element is not visible at all
        if (rect.height === 0 && rect.width === 0) {
          return;
        }

        // if elements dimensions are within window, resolve
        if (rect.top <= window.innerHeight && rect.bottom >= 0 && rect.left <= window.innerWidth && rect.right >= 0) {
          Events.removeResizeSubscriber(searching);
          Events.removeScrollSubscriber(searching);
          resolve();
        }
      }

      // Subscribe to some events
      Events.addResizeSubscriber(searching);
      Events.addScrollSubscriber(searching);
      Events.waitForWindowLoad().then(function() {
        searching();
      });

    });
  }

  /**
   * Return the lang param of <html>
   * @return {string} language
   */
  public getLanguage() {
    return document.documentElement.lang;
  }
}

var dom = new DOM();

export { dom as DOM }
